/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import '../../styles/input/input-text-field.scss';

const InputTextField = (props) => {
  const { label, name, warning, onChange,
    value, type, max, password, placeholder, autoComplete, onBlur, disabled } = props;
  const id = `${name}-${Math.floor(Math.random() * 1000)}`;
  const onTextChange = (e) => {
    let targetValue = '';
    switch (name) {
      case 'email': targetValue = e.target.value.trim();
        break;
      case 'serialNumber': targetValue = e.target.value.toUpperCase();
        break;
      default: targetValue = e.target.value;
    }
    onChange({ [name]: targetValue });
    e.persist();
  };
  const [showPassword, setShowPassword] = useState(password);
  return (
    <div className={`input-text-fieldRoot ${warning ? 'warning' : 'no-warning'} ${disabled ? 'disabled' : ''}`}>
      <label className="" data-shrink="false" htmlFor={id} id={`${id}-label`}>{label}</label>
      {type === 'text' && (
        <>
          {password && (
            <a
              className="password-show-btn"
              onClick={() => setShowPassword(!showPassword)}
              role="presentation"
            >
              {showPassword ? 'Show' : 'Hide'}
            </a>
          )}
          <input
            aria-invalid="false"
            id={id}
            placeholder={placeholder}
            autoComplete={autoComplete}
            type={!showPassword ? 'text' : 'password'}
            value={value}
            name={name}
            maxLength={max}
            onChange={(e) => onTextChange(e)}
            onBlur={onBlur}
            disabled={disabled}
          />
        </>
      )}
      {type === 'textarea' && (
        <textarea
          aria-invalid="false"
          id={id}
          placeholder={placeholder}
          rows="3"
          type="text"
          autoComplete={autoComplete}
          name={name}
          maxLength={max}
          onChange={(e) => onTextChange(e)}
          onBlur={onBlur}
        >
          {value}
        </textarea>
      )}
      {warning && (
      <p>
        <img src="/img/error.svg" alt="error" />
        {' '}
        <span>{warning}</span>
      </p>)}
    </div>
  );
};
InputTextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  warning: PropTypes.string,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  max: PropTypes.number,
  password: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
};
InputTextField.defaultProps = {
  label: '',
  name: '',
  max: 5000,
  warning: '',
  value: '',
  autoComplete: '',
  type: 'text',
  password: false,
  placeholder: ' ',
  onChange: () => { },
  onBlur: () => { },
  disabled: false
};
export default InputTextField;
